var SolutionFeedback = React.createClass({
  VOTE_YES: "yes",
  VOTE_NO: "no",
  propTypes: {
    viewCount: React.PropTypes.number,
    initalSolvedCount: React.PropTypes.number
  },
  getInitialState() {
    return {
      solvedCount: this.props.initalSolvedCount || 0
    }
  },
  yesClicked() {
    if (this.state.userVote) return;

	let disableSurveyUrl = `${Config.contextPath}/app/portlets/survey/disablesurvey.jsp`;
	$.get(disableSurveyUrl);

    RA.ViewKB.logAction("SOLVED");

    this.setState({solvedCount: this.state.solvedCount + 1,
      userVote: this.VOTE_YES});
  
	let {survey} = RA.ViewKB;
    if (survey.showSurveyOnYes && survey.yesSurveyID > 0) {
		let url = `${Config.contextPath}/app/portlets/survey/survey.jsp`;
		let params = {
			issolutionsurvey: true,
			surveyid: RA.ViewKB.survey.yesSurveyID,
			solutionid: RA.ViewKB.solution.id,
			solutiontitle: encodeURIComponent(RA.ViewKB.solution.title),
			solutioncollections: encodeURIComponent(RA.ViewKB.solution.collections),
			collectionsdescription: encodeURIComponent(RA.ViewKB.solution.collectionsDescription)
		};

		$.post(url, params, function (res) {
			res = res.replaceAll('action="survey.jsp"', 'action="../survey/survey.jsp"');

			let newWin = window.open(url, "ra.survey", "width=800,height=600,location=no,menubar=no,resizable=yes,status=yes,titlebar=yes,toolbar=no,scrollbars=yes");
			newWin.document.write(res);
		});
    }
  },
  noClicked() {
    if (this.state.userVote) return;

	let disableSurveyUrl = `${Config.contextPath}/app/portlets/survey/disablesurvey.jsp`;
	$.get(disableSurveyUrl);

    RA.ViewKB.logAction("UNSOLVED");
    this.setState({userVote: this.VOTE_NO});

    let {survey} = RA.ViewKB;
    if (survey.showSurveyOnNo && survey.id > 0) {
		let url = `${Config.contextPath}/app/portlets/survey/survey.jsp`;
		let params = { 
			issolutionsurvey: true, 
			surveyid: RA.ViewKB.survey.id, 
			solutionid: RA.ViewKB.solution.id, 
			solutiontitle: encodeURIComponent(RA.ViewKB.solution.title), 
			solutioncollections: encodeURIComponent(RA.ViewKB.solution.collections), 
			collectionsdescription: encodeURIComponent(RA.ViewKB.solution.collectionsDescription) 
		};

		$.post(url, params, function(res) {
			res = res.replaceAll('action="survey.jsp"', 'action="../survey/survey.jsp"');

			let newWin = window.open(url, "ra.survey", "width=800,height=600,location=no,menubar=no,resizable=yes,status=yes,titlebar=yes,toolbar=no,scrollbars=yes");
			newWin.document.write(res);
		});
    }

    if (Config.copyToIncidentEnabled) {
      window.close();
    }
  },
  render() {
    let yesClassName = "feedback__link",
      noClassName = "feedback__link",
      viewsLabel = this.props.viewCount == 1 ? "view" : "views";

    if (this.state.userVote == this.VOTE_YES) {
      yesClassName += " -up -voted";
      noClassName += " -disabled";
    } else if (this.state.userVote == this.VOTE_NO) {
      yesClassName += " -disabled";
      noClassName += " -down -voted";
    } else {
      yesClassName += " -up";
      noClassName += " -down";
    }

    return (
    /**
      <div className="feedback">
        <h3 className="aside__title">{Labels.getLabel("Did this help?")}</h3>

        <div className="feedback__vote">
          <a href="#" onClick={this.yesClicked} className={yesClassName}>
            <span className="glyphicon glyphicon-thumbs-up"></span>
            <span>{` ${Labels.getLabel("Yes")}`}</span>
          </a>
          <a href="#" onClick={this.noClicked} className={noClassName}>
            <span className="glyphicon glyphicon-thumbs-down"></span>
            <span>{` ${Labels.getLabel("No")}`}</span>
          </a>
        </div>

        <div className="aside__footer text-center">
          <div className="feedback__stat">
            <span className="glyphicon glyphicon-eye-open"></span>
            {` ${this.props.viewCount} ${Labels.getLabel(viewsLabel)}`}
          </div>
          <div className="feedback__stat">
            <span className="glyphicon glyphicon-thumbs-up"></span>
            {` ${this.state.solvedCount} ${Labels.getLabel("voted yes")}`}
          </div>
        </div>
      </div>
      **/
      
      /** Sage customizations for feedback ui **/
        <div className="feedback">
        <h3 className="aside__title">{Labels.getLabel("Did this help?")}</h3>

        <div className="feedback__vote">
          <a href="#" onClick={this.yesClicked} className={yesClassName}>
            <span className="glyphicon glyphicon-thumbs-up"></span>
            <span>{` ${Labels.getLabel("Yes")}`}</span>
          </a>
          <a href="#" onClick={this.noClicked} className={noClassName}>
            <span className="glyphicon glyphicon-thumbs-down"></span>
            <span>{` ${Labels.getLabel("No")}`}</span>
          </a>
        </div>

        <div className="aside__footer text-center">
          <div className="feedback__stat">
            <span className="glyphicon glyphicon-eye-open"></span>
            {` ${this.props.viewCount} ${Labels.getLabel(viewsLabel)}`}
          </div>
          <div className="feedback__stat">
            <span className="glyphicon glyphicon-thumbs-up"></span>
            {` ${this.state.solvedCount} ${Labels.getLabel("voted yes")}`}
          </div>
        </div>
      </div>
/** Sage customizations for feedback ui  ends here **/

    );
  }
});